import React from 'react';
import PropTypes from 'prop-types';
import { Filters } from '../../../../../constants/filter/filters';
import { FilterValues } from '../../../../../constants/filter/filter_values';
import { getSpeedIndexAbsoluteValue } from '../../../../../../_modules/tyre_index/get_speed_index_for_absolute_value';
import { MissingValue } from './missing_value';

function WithIndex({ highlight, filters, displayDimensions }) {
    const containerClassName = ['statusbar-mobile-current-status__size-cta'];
    const hasDisplayDimensions = displayDimensions && displayDimensions.trim().length > 0;
    if (highlight) {
        containerClassName.push('statusbar-mobile-current-status__size-cta--highlight-' + highlight);
    }

    let height = '/' + filters[Filters.HEIGHT];
    if (FilterValues.NONE === filters[Filters.HEIGHT] || !filters[Filters.HEIGHT]) {
        height = '';
    }

    const dimensionsLabel = hasDisplayDimensions ?
        displayDimensions :
        filters[Filters.WIDTH] && height && filters[Filters.DIAMETER] ? filters[Filters.WIDTH] + height + 'R' + filters[Filters.DIAMETER] : '';

    return (
        <span className={containerClassName.join(' ')}>
            {dimensionsLabel}
            {' '}
            {filters[Filters.LOAD_INDEX] || ''}
            {filters[Filters.SPEED_INDEX] ? getSpeedIndexAbsoluteValue(filters[Filters.SPEED_INDEX]) : ''}
        </span>
    );
}

WithIndex.propTypes = {
    filters: PropTypes.object.isRequired,
    highlight: PropTypes.string,
    displayDimensions: PropTypes.string,
};

WithIndex.defaultProps = {
    highlight: '',
    displayDimensions: '',
};

export { WithIndex };
